import { render, staticRenderFns } from "./down-time.vue?vue&type=template&id=f93afb56"
import script from "./down-time.vue?vue&type=script&lang=js"
export * from "./down-time.vue?vue&type=script&lang=js"
import style0 from "./down-time.vue?vue&type=style&index=0&id=f93afb56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports